import styles from "./CancellationReasonPopup.module.scss";
import { IUserSubscriptionCancellationReason } from "../../../../../models/SubscriptionHistory";
import React from "react";
import closeIcon from "../../../../../assets/images/icons/close-grey.svg";
import MainTitle from "../../../../../components/ui/MainTitle/MainTitle";
import { useTranslation } from "react-i18next";

interface CancellationReasonPopupProps {
  data: IUserSubscriptionCancellationReason;
  closePopup: () => void;
}

const CancellationReasonPopup: React.FC<CancellationReasonPopupProps> = ({ data, closePopup }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.popup}>
        <button onClick={closePopup} className={styles.closeBtn}>
          <img src={closeIcon} alt="close" />
        </button>
        <MainTitle size={20} text={t("CancellationReason")} />
        <div className={`${styles.popupContent} custom-scroll`}>
          <div className={styles.item}>
            <h4 className={styles.title}>{t("Reason")}</h4>
            <p className={styles.description}>{data.reason}</p>
          </div>
          <div className={styles.item}>
            <h4 className={styles.title}>{t("Comment")}</h4>
            <p className={styles.description}>{data.comment}</p>
          </div>
          <div className={styles.item}>
            <h4 className={styles.title}>{t("HowLikelyAreYouToRecommendClubPassToAFriend")}</h4>
            <p className={styles.description}>
              {data.rating || data.rating === 0 ? data.rating : "-"}
            </p>
          </div>
          <div className={styles.item}>
            <h4 className={styles.title}>{t("Why")}</h4>
            <p className={styles.description}>
              {data.additionalComment ? data.additionalComment : "-"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancellationReasonPopup;
